module.exports = __webpack_public_path__ + "double-r6siege-uk-desktop.jpg";